import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeInputField from '@s-ui/react-molecule-input-field'
import FormFieldTooltip from '@adv-mt/mt-form-field-tooltip'

const ROLE = 'search-text'
const SEARCH_TEXT_COMPONENT_TEST_ID = `${ROLE}-component`
const EMPTY_STRING = ''

const FormSearchText = ({label = 'COMMON_SEARCH_TEXT', onChange, tooltipContent, value = ''}) => {
  const {domain, i18n} = useContext(Context)
  const [currentValue, setCurrentValue] = useState(value)
  const [inputErrorText, setInputErrorText] = useState('')

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const noCodeRegex = config.get('REGEX_CODE')

  const labelText = i18n.t(label)
  const hasInputError = Boolean(inputErrorText)

  const _handleOnChange = (_, {value}) => {
    const decodedString = decodeURIComponent(value)
    const hasInvalidChars = noCodeRegex.test(decodedString)

    if (hasInvalidChars) {
      return setInputErrorText(i18n.t('COMMON.INVALID_FORMAT'))
    }
    setCurrentValue(value)
    setInputErrorText(EMPTY_STRING)
  }

  const handleUserInput = (e, value) => {
    setCurrentValue(value)
    onChange(e, {
      field: FILTER_NAMES.SEARCH_TEXT,
      value,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.SEARCH_TEXT]
    })
  }

  const _handleOnEnter = (e, {value}) => handleUserInput(e, value)

  const _handleOnBlur = e => handleUserInput(e, e.target.value)

  return (
    <div className="mt-FormSearchText" data-testid={SEARCH_TEXT_COMPONENT_TEST_ID}>
      <MoleculeInputField
        errorText={hasInputError && inputErrorText}
        label={labelText}
        onBlur={_handleOnBlur}
        onChange={_handleOnChange}
        onEnter={_handleOnEnter}
        value={currentValue}
      />
      {tooltipContent && !hasInputError ? (
        <div className="mt-FormSearchText-info">
          <FormFieldTooltip content={tooltipContent} />
        </div>
      ) : null}
    </div>
  )
}

FormSearchText.displayName = 'FormSearchText'
FormSearchText.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default FormSearchText
